<div [formGroup]="formGroup">
  <sc-select-field labelDictionaryKey="tmc-yard.common.type" formControlName="value" [data]="selectFieldOptions"></sc-select-field>
</div>
